// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/cerebrisanspro-bold-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/cerebrisanspro-bold-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/cerebrisanspro-regular-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/cerebrisanspro-regular-webfont.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  Optimize fonts using: https://www.fontsquirrel.com/tools/webfont-generator
*/

/* For regular text */
/* @font-face {
  font-family: 'CerebriSans';
  src: 
       url('./assets/fonts/CerebriSansPro-Regular.otf') format('opentype'),
       url('./assets/fonts/CerebriSansPro-Regular.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
} */
@font-face {
  font-family: 'CerebriSans';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'), /* modern browser */
       url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff'); /* fallback for IE */
  font-weight: 700;
  font-style: normal;
}

/* For bold text */
/* @font-face {
  font-family: 'CerebriSans';
  src: url('./assets/fonts/CerebriSansPro-Bold.otf') format('opentype'),
       url('./assets/fonts/CerebriSansPro-Bold.ttf') format('truetype');
  font-weight: bold;
  font-style: normal;
} */
@font-face {
  font-family: 'CerebriSans';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2'),
       url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff');
  font-weight: 400;
  font-style: normal;
}

/*
  1. Use a more-intuitive box-sizing model.
*/
*, *::before, *::after {
  box-sizing: border-box;
}

/*
  2. Remove default margin
*/
* {
  margin: 0;
}

/*
  3. Allow percentage-based heights in the application
*/
html, body {
  height: 100%;
  font-family: 'CerebriSans', 'sans-serif';
  
}

/*
  Typographic tweaks!
  4. Add accessible line-height
  5. Improve text rendering
*/
body {
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
}

/*
  6. Improve media defaults
*/
img, picture, video, canvas, svg {
  display: block;
  max-width: 100%;
}

/*
  7. Remove built-in form typography styles
*/
input, button, textarea, select {
  font: inherit;
}

/*
  8. Avoid text overflows
*/
p, h1, h2, h3, h4, h5, h6 {
  overflow-wrap: break-word;
}

/*
  9. Create a root stacking context
*/
#root, #__next {
  isolation: isolate;
}

#root {
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;CAEC;;AAED,qBAAqB;AACrB;;;;;;;GAOG;AACH;EACE,0BAA0B;EAC1B;6DAC0E,EAAE,oBAAoB;EAChG,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;;;;;;GAMG;AACH;EACE,0BAA0B;EAC1B;6DAC6E;EAC7E,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;CAEC;AACD;EACE,sBAAsB;AACxB;;AAEA;;CAEC;AACD;EACE,SAAS;AACX;;AAEA;;CAEC;AACD;EACE,YAAY;EACZ,wCAAwC;;AAE1C;;AAEA;;;;CAIC;AACD;EACE,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;;CAEC;AACD;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;;CAEC;AACD;EACE,aAAa;AACf;;AAEA;;CAEC;AACD;EACE,yBAAyB;AAC3B;;AAEA;;CAEC;AACD;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd","sourcesContent":["/*\n  Optimize fonts using: https://www.fontsquirrel.com/tools/webfont-generator\n*/\n\n/* For regular text */\n/* @font-face {\n  font-family: 'CerebriSans';\n  src: \n       url('./assets/fonts/CerebriSansPro-Regular.otf') format('opentype'),\n       url('./assets/fonts/CerebriSansPro-Regular.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n} */\n@font-face {\n  font-family: 'CerebriSans';\n  src: url('./assets/fonts/cerebrisanspro-bold-webfont.woff2') format('woff2'), /* modern browser */\n       url('./assets/fonts/cerebrisanspro-bold-webfont.woff') format('woff'); /* fallback for IE */\n  font-weight: 700;\n  font-style: normal;\n}\n\n/* For bold text */\n/* @font-face {\n  font-family: 'CerebriSans';\n  src: url('./assets/fonts/CerebriSansPro-Bold.otf') format('opentype'),\n       url('./assets/fonts/CerebriSansPro-Bold.ttf') format('truetype');\n  font-weight: bold;\n  font-style: normal;\n} */\n@font-face {\n  font-family: 'CerebriSans';\n  src: url('./assets/fonts/cerebrisanspro-regular-webfont.woff2') format('woff2'),\n       url('./assets/fonts/cerebrisanspro-regular-webfont.woff') format('woff');\n  font-weight: 400;\n  font-style: normal;\n}\n\n/*\n  1. Use a more-intuitive box-sizing model.\n*/\n*, *::before, *::after {\n  box-sizing: border-box;\n}\n\n/*\n  2. Remove default margin\n*/\n* {\n  margin: 0;\n}\n\n/*\n  3. Allow percentage-based heights in the application\n*/\nhtml, body {\n  height: 100%;\n  font-family: 'CerebriSans', 'sans-serif';\n  \n}\n\n/*\n  Typographic tweaks!\n  4. Add accessible line-height\n  5. Improve text rendering\n*/\nbody {\n  line-height: 1.5;\n  -webkit-font-smoothing: antialiased;\n}\n\n/*\n  6. Improve media defaults\n*/\nimg, picture, video, canvas, svg {\n  display: block;\n  max-width: 100%;\n}\n\n/*\n  7. Remove built-in form typography styles\n*/\ninput, button, textarea, select {\n  font: inherit;\n}\n\n/*\n  8. Avoid text overflows\n*/\np, h1, h2, h3, h4, h5, h6 {\n  overflow-wrap: break-word;\n}\n\n/*\n  9. Create a root stacking context\n*/\n#root, #__next {\n  isolation: isolate;\n}\n\n#root {\n  height: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
